import React from 'react';
import Modal from '@src/components/modal';
import { withoutProps } from '@src/utils/data-utils';
import isWindowOnload from '@src/utils/is-window-onload';

const ModalHOC = (extraProps = {}) => (Component, excludeProps = []) => {
  return class extends React.PureComponent {
    componentDidMount() {
      const { visible } = this.props;
      if (!visible) {
        this.handleWindowOnLoad = () => {
          // // noinspection JSUnusedLocalSymbols
          // const { visible, ...restProps } = this.props;
          // const { close } = Modal.append(() => (
          //   // display: none 背景图片不加载
          //   <div
          //     style={{
          //       width: 0,
          //       height: 0,
          //       visibility: 'hidden',
          //       overflow: 'hidden',
          //       position: 'absolute'
          //     }}
          //   >
          //     <Component {...withoutProps(restProps, excludeProps)} />
          //   </div>
          // ));
          //
          // this.close = close;
        };

        isWindowOnload().then(() => {
          this.handleWindowOnLoad();
        });
      }
    }

    removeWindowOnLoadListener() {
      this.handleWindowOnLoad = f => f;
    }

    componentWillUpdate() {
      const { visible } = this.props;
      visible && this.removeWindowOnLoadListener();
    }

    componentWillUnmount() {
      this.close && this.close();
      this.removeWindowOnLoadListener();
    }

    render() {
      const { modal, ...restProps } = this.props;
      const { withoutDefaultWrapModal, ...finalModalExtraProps } = extraProps;
      if (withoutDefaultWrapModal) {
        return <Component {...modal} {...withoutProps(restProps, excludeProps)} />;
      }
      return (
        <Modal {...finalModalExtraProps} {...modal}>
          <Component modal={modal} {...withoutProps(restProps, excludeProps)} />
        </Modal>
      );
    }
  };
};

export default ModalHOC;
